export default function TLMarquee() {
  const requests = [
    '«Нужно маркетинговое агентство»',
    '«Ищем подрядчика по разработке»',
    '«Требуется SEO-продвижение»',
    '«Нужен интегратор CRM»',
    '«Ищем поставщика услуг»',
    '«Кому заказать таргет?»',
    '«Нужен дизайнер UI/UX»',
    '«Подскажите по контекстной рекламе»',
  ];

  const doubled = [...requests, ...requests];

  return (
    <section className="bg-background-950 border-y border-background-50/5 py-6 overflow-hidden">
      <div className="flex items-center gap-3 mb-3 px-6 md:px-10 max-w-[1280px] mx-auto">
        <span className="w-2 h-2 rounded-full bg-primary-500 live-dot"></span>
        <span className="text-[11px] font-semibold uppercase tracking-[0.2em] text-background-50/50">
          Прямо сейчас в Telegram
        </span>
      </div>
      <div className="relative">
        <div className="flex gap-3 animate-marquee whitespace-nowrap will-change-transform">
          {doubled.map((req, i) => (
            <span
              key={i}
              className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-background-50/10 bg-background-50/[0.03] text-[14px] text-background-50/80"
            >
              <i className="ri-chat-3-line text-primary-400"></i>
              {req}
            </span>
          ))}
        </div>
        <div className="absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-background-950 to-transparent pointer-events-none"></div>
        <div className="absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-background-950 to-transparent pointer-events-none"></div>
      </div>
    </section>
  );
}